var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4997 39.3817C31.8234 39.3817 39.3817 31.8234 39.3817 22.4997C39.3817 13.176 31.8234 5.61768 22.4997 5.61768C13.176 5.61768 5.61768 13.176 5.61768 22.4997C5.61768 31.8234 13.176 39.3817 22.4997 39.3817Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1587 18.1589C18.6031 16.2435 20.3478 14.9154 22.3122 14.997C24.511 14.8752 26.396 16.5507 26.5328 18.7485C26.5328 21.5695 22.4999 22.5001 22.4999 24.3758",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7346 29.5353C22.7346 29.6647 22.6296 29.7697 22.5002 29.7697C22.3706 29.7697 22.2656 29.6647 22.2656 29.5353C22.2656 29.4058 22.3706 29.3008 22.5002 29.3008",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.2991C22.6296 29.2991 22.7346 29.4039 22.7346 29.5334",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationQuestions);
export default __webpack_public_path__ + "static/media/navigation-questions.83486b7e.svg";
export { ForwardRef as ReactComponent };